import { useEffect } from 'react';
import { FormikProps } from 'formik';
import { useDebouncedCallback } from 'use-debounce';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounceValidation = (formik: FormikProps<any>) => {
  const debouncedValidateForm = useDebouncedCallback(() => {
    formik.validateForm();
  }, 100);

  useEffect(() => {
    if (formik.isSubmitting) {
      debouncedValidateForm.cancel();
    }
  }, [formik.isSubmitting, debouncedValidateForm]);

  useEffect(() => {
    // Validate when values change, but debounced
    if (formik.dirty) {
      debouncedValidateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values, debouncedValidateForm]);
};
